(function () {
  'use strict';

  angular.module('sempraWebapp').factory('CampaignsViewModel', CampaignsViewModelFactory);

  /** @ngInject */
  function CampaignsViewModelFactory(gridUtils, $translate, campaignActions, localeFilters, CampaignItemViewModel, sessionData, dialogsService) {
    function CampaignsViewModel() {
      this.currentPage = 1;
      this.orderBy = '-from';
      this.hasErrorMessage = false;
      this.errorMessage = $translate.instant('DELETE_CAMPAIGN_ERROR');
      this.data = [];
      this.selected = [];
      this.count = 0;
      this.multiple = false;
      this.listEmpty = false;

      this.gridOptions = {
        multiple: false
      };
      this.treshold = 1;
      this.tresholdTypes = [{
        id: 'VISITS',
        name: 'NUMBER_OF_VISITS'
      }, {
        id: 'MONEY',
        name: 'TOTAL_MONEY_SPENT'
      }];
      this.selectedTresholdType = 'VISITS';

      this.dateFormat = localeFilters.defaultDateFormat;

      this.from = new Date();
      this.to = new Date();

      this.totalUsers = 0;
      this.chart = {
        data: null,
        x: {
          type: 'timeseries',
          tick: {
            centered: true,
            culling:{
              max : 7
            },
            format: function (item) {
              return localeFilters.date(item);
            },
            fit : true,
            rotate: 60
          }
        }
      };

      this.message = $translate.instant('CAMPAIGN_DEFAULT_SMS_MESSAGE');

      init.call(this);
    }

    CampaignsViewModel.prototype.destroy = function () {
      this.data.forEach(function (itemViewModel) {
        itemViewModel.destroy();
      });
    };

    CampaignsViewModel.prototype.refresh = refresh;

    CampaignsViewModel.prototype.onPeriodFromChanged = function () {
    };

    CampaignsViewModel.prototype.onPeriodToChanged = function () {
    };

    CampaignsViewModel.prototype.getTresholds = function () {
      var that = this,
          campaignId = this.selected[0].id,
          type = this.selectedTresholdType,
          tresholdValue = this.treshold,
          fromTimestamp = this.from.getTime(),
          toTimestamp = this.to.getTime();

      campaignActions.getLoyaltyTresholds(campaignId, type, tresholdValue, fromTimestamp, toTimestamp).then(function (data) {
        that.chart.data = data;
        that.totalUsers = data.total;
      });
    };

    CampaignsViewModel.prototype.sendMessage = function(){
      var that = this;
      dialogsService.showConfirmDialog($translate.instant('ARE_YOU_SURE'), $translate.instant('SEND_MESSAGE_NOTIFICATION'), $translate.instant('YES')).then(function(){
        campaignActions.sendCampaignUsersMessage(that.selected[0].id, that.treshold, that.selectedTresholdType, that.message);
      });
    };

    CampaignsViewModel.prototype.activateCampaign = function (campaign) {
      dialogsService.showConfirmDialog($translate.instant('ARE_YOU_SURE'), $translate.instant('ACTIVATE_CAMPAIGN_CONFIRMATION_MSG')+' '+campaign.name+' '+$translate.instant('CAMPAIGN'), $translate.instant('YES')).then(function(){
        campaignActions.activateCampaign(campaign.id).then(function () {
          campaign.activateCampaign();
        });
      });
    };

    return CampaignsViewModel;

    function init() {
      var gridSettings = gridUtils.getDefaultGridSettings();
      // this.limitPerPage = gridSettings.limitPerPage;
      this.limitPerPage = 10;
      this.pagerLabel = gridSettings.translations;
    }

    function refresh(campaignsArrayJson, userGroupsArrayJson) {
      var that = this;

      this.data = [];
      this.selected = [];
      this.count = 0;

      if(campaignsArrayJson.length === 0){
        this.listEmpty = true;
      }
      
      this.isSystemAdmin = (sessionData.getValue('userRole') === 'SYSTEM_ADMIN') ? true : false;
      this.hasErrorMessage = false;
      if (campaignsArrayJson) {
        that.count = campaignsArrayJson.length;
        campaignsArrayJson.forEach(function (campaignJson) {

          var fromDate = new Date(campaignJson.from);
          var toDate = new Date(campaignJson.to);
          var currentDate = new Date();

          if(fromDate < toDate && currentDate < fromDate){
            campaignJson.isInFuture = true;
          }else{
            campaignJson.isInFuture = false;
          }

          this.push(new CampaignItemViewModel(campaignJson, userGroupsArrayJson));
        }, this.data);
        
      }
    }
  }
})();
